import type { IPersonalDataProtectionPolicy } from '../../interfaces/personal-data-protection-policy.interface';
import type { IConsentState, Source, TConsentType } from '../../types';

export class NoopPolicy implements IPersonalDataProtectionPolicy {
    public isConsentRequired(actionType: TConsentType, source: Source): boolean {
        return false;
    }

    public saveConsent(result: IConsentState): void {
        return;
    }

    public getGlobalConsentState(): IConsentState {
        return { default: true };
    }
}

export class NinjaPolicy implements IPersonalDataProtectionPolicy {
    public getGlobalConsentState(): IConsentState {
        // Usually we just have to return current consent state from cookies or localStorage.
        return {};
    }

    public isConsentRequired(consentType: 'default' | 'tracking' | 'cookies' | string, source: Source): boolean {
        switch (consentType) {
            case 'tracking':
                return true;
            case 'cookies':
                return false;
            default:
                return true;
        }
    }

    public saveConsent(result: IConsentState): void {
        // Save state to the storage
    }
}
